import {inject} from '@angular/core';
import {CanActivateFn, Router} from '@angular/router';
import {SeguridadService} from '@/services/seguridad.service';

export const EsRitualsGuard: CanActivateFn = () => {

    const seguridadService = inject(SeguridadService);
    const router = inject(Router);

    const rol = seguridadService.obtenerRol();
    const cliente = seguridadService.obtenerCliente();
    const negocio = seguridadService.obtenerNegocio();

    let roles = ["Externo"];

    if (cliente == "shopology" && roles.includes(rol) && negocio == "rituals") {
        return true;
    }

    router.navigateByUrl('/rituals');
    return false;
}
